import React from 'react';
import SectionLayout from 'atoms/Layout/Section/SectionLayout';
import TonyRobbinsArenaFeed from 'organisms/Homepage/TonyRobbinsArenaFeed/TonyRobbinsArenaFeed';

const TonyRobbinsArena = (): JSX.Element => (
  <SectionLayout
    maxWidth='width-3xl'
    padding={['spacing-7xl', 'spacing-4xl']}
    paddingSm={['spacing-4xl', 'spacing-xl']}
    background='bg-tertiary'
  >
    <TonyRobbinsArenaFeed />
  </SectionLayout>
);

export default TonyRobbinsArena;
